import { isProduction } from '@zapier/common-utils';

const ZAPIER_APP_BASE_URL = process.env.ZAPIER_APP_BASE_URL || '';

export const PLATFORM_ROOT = '/platform';

export const BASE_APP_URL = '/app/developer';
export const LEGACY_BUILDER_BASE_URL = `${ZAPIER_APP_BASE_URL}/developer/builder`;
export const LOGIN_URL = `${ZAPIER_APP_BASE_URL}${PLATFORM_ROOT}/login`;
export const JOIN_INTEGRATION_URL = '/join-integration';
export const PLATFORM_TOS_URL = '/platform/tos';
export const PRIVACY_POLICY_URL = '/privacy';
export const SIGNUP_URL = `${ZAPIER_APP_BASE_URL}${PLATFORM_ROOT}/sign-up`;
export const USER_TOS_URL = '/terms';
export const VB_BASE_URL = isProduction()
  ? 'https://developer.zapier.com'
  : 'https://developer.zapier-staging.com';
